import React, { Component } from "react";
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import queryString from 'query-string';
//import { useLocation } from "react-router";

import App from './App.js';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
 
);
function testfunction(){
	console.log('testfunction');
}


{/*
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

*/}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
